export default __webpack_public_path__ + "static/farm_staff_upgrade-6c68ece2c624437ab0db0ca6ffe7c142.png";